const dramas = [
  {
    title: '大奉打更人',
    genre: '古装奇幻',
    tag: '热播中',
    desc: '许七安穿越到大奉王朝，凭借现代知识与古代智慧，步步为营破解朝堂迷局',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20drama%20scene%20with%20scholar%20in%20traditional%20robes%20under%20moonlight%2C%20mysterious%20imperial%20palace%20courtyard%2C%20warm%20lantern%20light%2C%20cinematic%20composition%2C%20historical%20drama%20aesthetic&width=800&height=560&seq=cards-drama-01&orientation=landscape',
  },
  {
    title: '白夜破晓',
    genre: '悬疑犯罪',
    tag: '高分推荐',
    desc: '双胞胎兄弟互换身份追查真相，层层反转的案情带你感受极致烧脑体验',
    img: 'https://readdy.ai/api/search-image?query=Dark%20urban%20night%20scene%20in%20modern%20Chinese%20city%2C%20rain%20on%20street%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20crime%20thriller%20atmosphere%2C%20dramatic%20shadows%2C%20noir%20cinematic%20style&width=800&height=560&seq=cards-drama-02&orientation=landscape',
  },
  {
    title: '南来北往',
    genre: '年代情感',
    tag: '口碑佳作',
    desc: '七十年代铁路大院里的温情故事，两代人的命运交织与时代变迁的感人画卷',
    img: 'https://readdy.ai/api/search-image?query=Retro%201970s%20Chinese%20railway%20station%20with%20steam%20train%2C%20nostalgic%20warm%20lighting%2C%20vintage%20atmosphere%2C%20period%20drama%20setting%2C%20family%20gathering%20on%20platform%2C%20golden%20evening%20light&width=800&height=560&seq=cards-drama-03&orientation=landscape',
  },
  {
    title: '狐妖小红娘',
    genre: '古装仙侠',
    tag: '新剧上架',
    desc: '人妖之恋跨越千年，唯美仙侠世界里的爱恨纠葛与命运轮回，画面绝美',
    img: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20romance%20scene%20with%20cherry%20blossoms%20and%20ancient%20temple%2C%20soft%20pink%20and%20gold%20tones%2C%20floating%20lanterns%2C%20dreamy%20atmosphere%2C%20traditional%20Chinese%20aesthetic%2C%20cinematic%20beauty&width=800&height=560&seq=cards-drama-04&orientation=landscape',
  },
  {
    title: '城中之城',
    genre: '都市金融',
    tag: '热播推荐',
    desc: '金融街精英的权谋博弈，商战与人性的双重较量，展现当代都市职场浮世绘',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Shanghai%20financial%20district%20skyline%20at%20dusk%2C%20glass%20skyscrapers%20reflecting%20golden%20light%2C%20contemporary%20business%20drama%20setting%2C%20luxury%20office%20interior%20view%2C%20cinematic%20corporate%20aesthetic&width=800&height=560&seq=cards-drama-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-600 text-xs font-medium mb-3">
            <i className="ri-thumb-up-line"></i>
            编辑精选
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热剧推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-2">编辑精选优质剧集，每一部都值得追</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {dramas.map((drama) => (
            <div
              key={drama.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 cursor-pointer transition-all hover:-translate-y-1"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={drama.img}
                  alt={`小草影院${drama.title}高清在线观看`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {drama.genre}
                  </span>
                  <span className="text-[10px] px-2 py-0.5 rounded bg-accent-100 text-accent-600 whitespace-nowrap">
                    {drama.tag}
                  </span>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1">{drama.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{drama.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}